import State from '../interfaces/states/State';

import { createSelector } from 'reselect';

const getUserFirstName = createSelector(
  (state: State) => state.findUser.userInfo,
  (userInfo): string => {
    // @ts-ignore
    if (userInfo.data) {
      // @ts-ignore
      return userInfo.data[0].first_name.charAt(0).toUpperCase() + userInfo.data[0].first_name.toLowerCase().slice(1);
    } else {
      return null;
    }
  }
);

export default getUserFirstName;
